import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'

import Typography, { TypographyProps } from '../base/Typography'
import { cn } from '@/lib/utils'

export type TextBlockProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title: string
    titleVariant?: TypographyProps['variant']
    titleComponent?: TypographyProps['component']
    paragraph: string
  }>

const TextBlock = ({
  title,
  titleVariant,
  titleComponent,
  paragraph,
  className,
  ...props
}: TextBlockProps) => {
  return (
    <section
      className={cn(
        [
          'scrollbar-hidex fixed left-0 top-0 h-full w-full overflow-auto',
          'flex bg-black-light/100'
        ],
        className
      )}
      {...props}
    >
      <Container className="">
        <Grid className="gap-y-spacing-md pb-[10rem] pt-[8rem] md:pt-[10rem]">
          <div className="col-span-4 flex md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3 xl:col-span-6 xl:col-start-4">
            <Typography variant={titleVariant} component={titleComponent}>
              {title}
            </Typography>
          </div>
          <div className="col-span-4 flex md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3 xl:col-span-6 xl:col-start-4">
            <Typography variant="regular" className="block">
              {paragraph}
            </Typography>
          </div>
        </Grid>
      </Container>
    </section>
  )
}

export default TextBlock
